import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { firstValueFrom } from "rxjs";
import { environment } from "../../../../Environments/Environment";
import { SearchSessionRequest } from "../Dto/SessionSearchRequest";
import { SearchSessionResponse } from "../Dto/SessionModel";

@Injectable({ providedIn: "root" })
export class SessionApi {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = environment.adminServiceUrl;

  async searchSessions(params: SearchSessionRequest): Promise<SearchSessionResponse> {
    const url = new URL("sessions", `${this.baseUrl}/`);
    const searchParams = new URLSearchParams();

    if (params.search) {
      searchParams.set("search", params.search);
    }

    if (params.userId) {
      searchParams.set("userId", params.userId);
    }

    if (params.userAgent) {
      searchParams.set("userAgent", params.userAgent);
    }

    if (params.deviceModel) {
      searchParams.set("deviceModel", params.deviceModel);
    }

    if (params.deviceOs) {
      searchParams.set("deviceOs", params.deviceOs);
    }

    if (params.deviceBrowser) {
      searchParams.set("deviceBrowser", params.deviceBrowser);
    }

    if (params.createdAtFrom) {
      searchParams.set("createdAtFrom", params.createdAtFrom);
    }

    if (params.createdAtTo) {
      searchParams.set("createdAtTo", params.createdAtTo);
    }

    if (params.page !== undefined) {
      searchParams.set("page", params.page.toString());
    }

    if (params.limit !== undefined) {
      searchParams.set("limit", params.limit.toString());
    }

    if (searchParams.toString()) {
      url.search = searchParams.toString();
    }

    return await firstValueFrom(this.http.get<SearchSessionResponse>(url.toString(), { withCredentials: true }));
  }

  async deleteSession(sessionId: string): Promise<void> {
    return await firstValueFrom(this.http.delete<void>(`${this.baseUrl}/sessions/${sessionId}`, { withCredentials: true }));
  }
}
